var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { computePerformanceTime, getElementPerformanceMetric, getMeasureMetric, getNavigationMetric, getPaintMetric, getResourcePerformanceMetric, keys, uuidv4 } from "./utils";
/**
 * Records metrics.
 * @param metrics the metrics collection.
 * @param apiURL the keyper-telemetry-services api url.
 * @param beforeSend a callback to fire before sending telemetry; return null from this to cancel telemetry.
 * @returns `string`
 */
export function recordMetrics(metrics, apiURL, beforeSend) {
    return __awaiter(this, void 0, void 0, function () {
        var _metrics, bsRes, err_1, body, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _metrics = [];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 8, , 9]);
                    /** For each metric kind:
                     * 1. find the previously recorded transaction if available and store it.
                     * 2. create a unique transaction id (tid)
                     * 3. add the metric (details + previous transaction + tid) to the `_metrics` list.
                     * 4. set the current metric kind or transactionName and tid as the new previousTransaction
                     * 5. after compiling the metrics list, fire `beforeSend` callback.
                     * 6. Finally, if `beforeSend` callback does not return null, send payload to keyper telemetry services.
                     */
                    metrics.forEach(function (metric) {
                        var previousTransaction = {};
                        try {
                            var prevTransaction = JSON.parse(sessionStorage.getItem(keys.previousTransaction));
                            previousTransaction.previousTransaction = prevTransaction.previousTransaction;
                            previousTransaction.previousTransactionId = prevTransaction.previousTransactionId;
                        }
                        catch (err) {
                            previousTransaction.previousTransaction = null;
                            previousTransaction.previousTransactionId = null;
                        }
                        var tid = uuidv4();
                        switch (metric.kind) {
                            case "did-not-render": {
                                var _a = metric, _b = _a.app, app = _b === void 0 ? "" : _b, _c = _a.componentName, componentName = _c === void 0 ? "" : _c, _d = _a.environment, environment = _d === void 0 ? "" : _d, _e = _a.kind, kind = _e === void 0 ? "did-not-render" : _e, _f = _a.parentElement, parentElement = _f === void 0 ? "" : _f, _g = _a.rootElement, rootElement = _g === void 0 ? "" : _g, timestamp = _a.timestamp;
                                _metrics.push(__assign(__assign({ app: app, componentName: componentName, environment: environment, kind: kind, parentElement: parentElement }, previousTransaction), { rootElement: rootElement, tid: tid, timestamp: timestamp }));
                                sessionStorage.setItem(keys.previousTransaction, JSON.stringify({
                                    previousTransaction: kind,
                                    previousTransactionId: tid
                                }));
                                break;
                            }
                            case "element": {
                                var _h = metric, _j = _h.app, app = _j === void 0 ? "" : _j, _k = _h.element, element = _k === void 0 ? null : _k, _l = _h.environment, environment = _l === void 0 ? "" : _l, _m = _h.id, id = _m === void 0 ? "" : _m, _o = _h.identifier, identifier = _o === void 0 ? "" : _o, _p = _h.kind, kind = _p === void 0 ? "element" : _p, _q = _h.loadTime, loadTime = _q === void 0 ? 0 : _q, _r = _h.renderTime, renderTime = _r === void 0 ? 0 : _r, timestamp = _h.timestamp, _s = _h.url, url = _s === void 0 ? "" : _s;
                                _metrics.push(__assign(__assign({ app: app, element: element, environment: environment, id: id, identifier: identifier, kind: kind, loadTime: loadTime }, previousTransaction), { renderTime: renderTime, tid: tid, timestamp: timestamp, url: url }));
                                sessionStorage.setItem(keys.previousTransaction, JSON.stringify({
                                    previousTransaction: kind,
                                    previousTransactionId: tid
                                }));
                                break;
                            }
                            case "error": {
                                var _t = metric, _u = _t.app, app = _u === void 0 ? "" : _u, colno = _t.colno, _v = _t.environment, environment = _v === void 0 ? "" : _v, filename = _t.filename, isTrusted = _t.isTrusted, _w = _t.kind, kind = _w === void 0 ? "error" : _w, lineno = _t.lineno, _x = _t.name, name_1 = _x === void 0 ? "" : _x, _y = _t.message, message = _y === void 0 ? "" : _y, _z = _t.stack, stack = _z === void 0 ? "" : _z, timestamp = _t.timestamp;
                                _metrics.push(__assign(__assign({ app: app, colno: colno, environment: environment, filename: filename, isTrusted: isTrusted, kind: kind, lineno: lineno }, previousTransaction), { name: name_1, message: message, stack: stack, tid: tid, timestamp: timestamp }));
                                sessionStorage.setItem(keys.previousTransaction, JSON.stringify({
                                    previousTransaction: kind,
                                    previousTransactionId: tid
                                }));
                                break;
                            }
                            case "gql":
                            case "measure": {
                                var _0 = metric, _1 = _0.app, app = _1 === void 0 ? "" : _1, _2 = _0.detail, detail = _2 === void 0 ? "" : _2, _3 = _0.decodedBodySize, decodedBodySize = _3 === void 0 ? 0 : _3, _4 = _0.encodedBodySize, encodedBodySize = _4 === void 0 ? 0 : _4, _5 = _0.environment, environment = _5 === void 0 ? "" : _5, _6 = _0.kind, kind = _6 === void 0 ? "measure" : _6, _7 = _0.latency, latency = _7 === void 0 ? 0 : _7, startTime = _0.startTime, timestamp = _0.timestamp, transactionName = _0.transactionName, _8 = _0.transferSize, transferSize = _8 === void 0 ? 0 : _8, _9 = _0.url, url = _9 === void 0 ? "" : _9;
                                _metrics.push(__assign(__assign({ app: app, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, detail: detail, environment: environment, kind: kind, latency: latency, transactionName: transactionName }, previousTransaction), { startTime: startTime, transferSize: transferSize, tid: tid, timestamp: timestamp, url: url }));
                                sessionStorage.setItem(keys.previousTransaction, JSON.stringify({
                                    previousTransaction: transactionName,
                                    previousTransactionId: tid
                                }));
                                break;
                            }
                            case "navigation": {
                                var _10 = metric, _11 = _10.app, app = _11 === void 0 ? "" : _11, _12 = _10.duration, duration = _12 === void 0 ? 0 : _12, _13 = _10.environment, environment = _13 === void 0 ? "" : _13, _14 = _10.kind, kind = _14 === void 0 ? "navigation" : _14, timestamp = _10.timestamp, _15 = _10.type, type = _15 === void 0 ? "" : _15, _16 = _10.url, url = _16 === void 0 ? "" : _16;
                                _metrics.push(__assign(__assign({ app: app, duration: duration, environment: environment, kind: kind }, previousTransaction), { tid: tid, timestamp: timestamp, type: type, url: url }));
                                sessionStorage.setItem(keys.previousTransaction, JSON.stringify({
                                    previousTransaction: kind,
                                    previousTransactionId: tid
                                }));
                                break;
                            }
                            case "paint": {
                                var _17 = metric, _18 = _17.app, app = _18 === void 0 ? "" : _18, _19 = _17.environment, environment = _19 === void 0 ? "" : _19, _20 = _17.kind, kind = _20 === void 0 ? "paint" : _20, _21 = _17.latency, latency = _21 === void 0 ? 0 : _21, timestamp = _17.timestamp, _22 = _17.type, type = _22 === void 0 ? "" : _22;
                                _metrics.push(__assign(__assign({ app: app, environment: environment, kind: kind, latency: latency }, previousTransaction), { tid: tid, timestamp: timestamp, type: type }));
                                sessionStorage.setItem(keys.previousTransaction, JSON.stringify({
                                    previousTransaction: kind,
                                    previousTransactionId: tid
                                }));
                                break;
                            }
                            case "resource": {
                                var _23 = metric, _24 = _23.app, app = _24 === void 0 ? "" : _24, _25 = _23.decodedBodySize, decodedBodySize = _25 === void 0 ? 0 : _25, _26 = _23.encodedBodySize, encodedBodySize = _26 === void 0 ? 0 : _26, _27 = _23.environment, environment = _27 === void 0 ? "" : _27, _28 = _23.kind, kind = _28 === void 0 ? "resource" : _28, _29 = _23.latency, latency = _29 === void 0 ? 0 : _29, timestamp = _23.timestamp, _30 = _23.transactionName, transactionName = _30 === void 0 ? "" : _30, _31 = _23.transferSize, transferSize = _31 === void 0 ? 0 : _31, _32 = _23.url, url = _32 === void 0 ? "" : _32;
                                _metrics.push(__assign(__assign({ app: app, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, environment: environment, kind: kind, latency: latency }, previousTransaction), { tid: tid, timestamp: timestamp, transactionName: transactionName, transferSize: transferSize, url: url }));
                                sessionStorage.setItem(keys.previousTransaction, JSON.stringify({
                                    previousTransaction: transactionName,
                                    previousTransactionId: tid
                                }));
                                break;
                            }
                            default:
                                break;
                        }
                    });
                    bsRes = void 0;
                    if (!beforeSend) return [3 /*break*/, 5];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, beforeSend(_metrics)];
                case 3:
                    bsRes = _a.sent();
                    if (bsRes === null)
                        return [2 /*return*/]; // early return if the `beforeSend` callback return null (gives users sampling control).
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _a.sent();
                    void 0;
                    return [3 /*break*/, 5];
                case 5:
                    body = JSON.stringify(_metrics);
                    return [4 /*yield*/, fetch(apiURL, {
                            method: 'POST',
                            mode: 'cors',
                            headers: { 'Content-Type': 'application/json' },
                            body: body
                        })];
                case 6: return [4 /*yield*/, (_a.sent()).json()];
                case 7: 
                // The following line is to support sendBeacon api.
                // return (navigator.sendBeacon && navigator.sendBeacon(apiURL, body)) || await (await fetch(apiURL, {
                return [2 /*return*/, _a.sent()];
                case 8:
                    err_2 = _a.sent();
                    return [2 /*return*/]; // swallow error
                case 9: return [2 /*return*/];
            }
        });
    });
}
/**
 * Gets a KeyperProps from remote.
 * @param apiURL
 * @param body The app and environment.
 * @returns `KeyperProps`
 */
export function getConfig() {
    return __awaiter(this, void 0, void 0, function () {
        var hostname, keyperProps, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    hostname = window.location.hostname + ".json";
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(getConfigServiceUrl, {
                            method: 'POST',
                            mode: 'cors',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ hostname: hostname }),
                        })];
                case 2: return [4 /*yield*/, (_a.sent()).json()];
                case 3:
                    keyperProps = _a.sent();
                    return [2 /*return*/, {
                            activated: keyperProps.activated,
                            apiURL: telemetryServiceUrl,
                            app: keyperProps.app,
                            environment: keyperProps.environment,
                            hostname: keyperProps.hostname,
                            elementIds: Array.isArray(keyperProps.elementIds) ? keyperProps.elementIds : [],
                            gqlResources: Array.isArray(keyperProps.gqlResources) ? keyperProps.gqlResources : [],
                            navigationTypes: Array.isArray(keyperProps.navigationTypes) ? keyperProps.navigationTypes : [],
                            paintTypes: Array.isArray(keyperProps.paintTypes) ? keyperProps.paintTypes : [],
                            resources: Array.isArray(keyperProps.resources) ? keyperProps.resources : [],
                            ignoreErrors: Array.isArray(keyperProps.ignoreErrors) ? keyperProps.ignoreErrors : []
                        }];
                case 4:
                    err_3 = _a.sent();
                    return [2 /*return*/, {
                            activated: false,
                            apiURL: '',
                            app: '',
                            environment: '',
                            hostname: '',
                            elementIds: [],
                            gqlResources: [],
                            navigationTypes: [],
                            paintTypes: [],
                            resources: [],
                            ignoreErrors: []
                        }];
                case 5: return [2 /*return*/];
            }
        });
    });
}
export var getCBAppDetailsFromHost = function () {
    var hostname = window.location.hostname;
    var parts = hostname.split('.');
    // Assume that if there are 3 parts to the hostname and it does not include a nonprod signifier, that we are in prod.
    var isProd = parts.length === 3 && !["nonprod", "playground"].some(function (env) { return hostname.includes(env); });
    var _a = (function () {
        if (isProd)
            return [parts[0], "prod"];
        if (parts.length === 3) {
            return [parts[0].split('-')[0], "nonprod"];
        }
        else {
            return [hostname.split(".collegeboard.org")[0], "nonprod"];
        }
    })(), app = _a[0], environment = _a[1];
    return {
        app: app,
        environment: environment
    };
};
// export const getApiUrl = () =>
//   getCBAppDetailsFromHost().environment === "prod"
//     ? telemetryServiceUrl
//     : telemetryServiceUrlNonProd;
export var getConfigServiceUrl = "https://keyper-api.monitoring-admin.collegeboard.org/v1/get-client-config";
export var getConfigServiceUrlNonProd = "https://keyper-api.monitoring-nonprod.collegeboard.org/v1/get-client-config";
export var telemetryServiceUrl = "https://keyper-telemetry.monitoring-admin.collegeboard.org";
// export const landscapeTelemetryServiceUrl = "https://keyper-telemetry.tecd-prod.collegeboard.org";
export var telemetryServiceUrlNonProd = "https://keyper-telemetry.monitoring-nonprod.collegeboard.org";
/**
 * Creates a `PerformanceObserver` which will record metrics based on the `KeyperConfig` provided.
 * @param config a `KeyperConfig`.
 * @returns a `PerformanceObserver`.
 */
export var performanceObserverFactory = function (config) {
    return new PerformanceObserver(function (l, o) { return observer_callback(l, o, config); });
};
/**
 * Handles `PerformanceObserver` events by using the `KeyperConfig` to create and record metric payloads.
 * @param list the `PerformanceObserverEntryList` to act on.
 * @param observer the `PerformanceObserver`.
 * @param keyperConfig the `KeyperConfig` the observer should act on.
 * @returns
 */
function observer_callback(list, observer, _a) {
    var apiURL = _a.apiURL, app = _a.app, beforeSend = _a.beforeSend, data = _a.data, environment = _a.environment, elementIds = _a.elementIds, gqlResources = _a.gqlResources, navigationTypes = _a.navigationTypes, paintTypes = _a.paintTypes, rs = _a.resources;
    var _b = getCBAppDetailsFromHost(), cbApp = _b.app, cbEnv = _b.environment;
    /** The metadata to be included with every recorded performance metric. */
    var metricMetadata = {
        app: cbApp,
        data: data,
        environment: cbEnv,
    };
    // Prevent allowing resources to include graphql endpoint (experimental:) - sk
    var resources = rs === null || rs === void 0 ? void 0 : rs.filter(function (r) { return !(gqlResources === null || gqlResources === void 0 ? void 0 : gqlResources.map(function (g) { return g.endpoint; }).includes(r.url)); });
    /* Filters */
    /**
     *
     * @param e a `PerformanceElementTiming` entry.
     * @returns `true` if found in the `elementIds` parameter of the keyper config.
     */
    var on_watched_elements = function (e) {
        return elementIds === null || elementIds === void 0 ? void 0 : elementIds.includes(e.identifier);
    };
    /**
     *
     * @param m a `PerformanceMeasure` entry.
     * @returns `true` if found in the `opNames` parameter for `gqlResources` of the keyper config.
     */
    var on_watched_measures = function (m) {
        return gqlResources === null || gqlResources === void 0 ? void 0 : gqlResources.flatMap(function (r) { return r.opNames; }).includes(m.name);
    };
    /**
     *
     * @param n a `PerformanceNavigationTiming` entry.
     * @returns `true` if found in the `navigationTypes` parameter of the keyper config.
     */
    var on_watched_navigation = function (n) {
        return navigationTypes === null || navigationTypes === void 0 ? void 0 : navigationTypes.includes(n.type);
    };
    /**
     *
     * @param p a `PerformancePaintTiming` entry.
     * @returns `true` if found in the `paintTypes` parameter of the keyper config.
     */
    var on_watched_paints = function (p) {
        return paintTypes === null || paintTypes === void 0 ? void 0 : paintTypes.includes(p.name);
    };
    /**
     *
     * @param r a `PerformanceResourceTiming` entry.
     * @returns `true` if the url is found in the `resources` parameter of the keyper config.
     */
    var on_watched_resources = function (r) {
        return resources === null || resources === void 0 ? void 0 : resources.map(function (kt) { return kt.url; }).includes(r.name);
    };
    /**
     *
     * @param r a `PerformanceResourceTiming` entry.
     * @returns `true` if the url is found in the `resources` parameter of the keyper config.
     */
    var on_watched_resources2 = function (r) {
        return !!(resources === null || resources === void 0 ? void 0 : resources.find(function (kt) { return r.name.includes(kt.url); }));
    };
    /* Mappers */
    /**
     * Maps a `PerformanceElementTiming` entry to an `ElementMetric`
     * @param e a `PerformanceElementTiming` entry.
     * @returns an `ElementMetric`.
     */
    var to_element_metrics = function (e) { return (__assign(__assign(__assign({}, getElementPerformanceMetric(e.identifier, list)), metricMetadata), { previousTransaction: null, previousTransactionId: null, timestamp: computePerformanceTime(e.startTime) })); };
    /**
     * Maps a `PerformanceMeasure` entry to a `MeasureMetric|GraphQLMetric`
     * @param m a `PerformanceMeasure` entry.
     * @returns a `MeasureMetric|GraphQLMetric`.
     */
    var to_measure_metrics = function (m) { return (__assign(__assign(__assign({}, getMeasureMetric(m.name, list)), metricMetadata), { previousTransaction: null, previousTransactionId: null, timestamp: computePerformanceTime(m.startTime) })); };
    /**
     * Maps a `PerformanceNavigationTiming` entry to a `NavigationMetric`
     * @param n a `PerformanceNavigationTiming` entry.
     * @returns a `NavigationMetric`.
     */
    var to_navigation_metrics = function (n) { return (__assign(__assign(__assign({}, getNavigationMetric(n.type, list)), metricMetadata), { previousTransaction: null, previousTransactionId: null, timestamp: computePerformanceTime(n.startTime) })); };
    /**
     * Maps a `PerformancePaintTiming` entry to a `PaintMetric`
     * @param p a `PerformancePaintTiming` entry.
     * @returns a `PaintMetric`.
     */
    var to_paint_metrics = function (p) { return (__assign(__assign(__assign({}, getPaintMetric(p.name, list)), metricMetadata), { previousTransaction: null, previousTransactionId: null, timestamp: computePerformanceTime(p.startTime) })); };
    /**
     * Maps a `PerformanceResourceTiming` entry to a `ResourceMetric`
     * @param r a `PerformanceResourceTiming` entry.
     * @returns a `ResourceMetric`.
     */
    var to_resource_metrics = function (r) {
        var _a;
        return (__assign(__assign(__assign({}, getResourcePerformanceMetric(r.name, list)), metricMetadata), { previousTransaction: null, previousTransactionId: null, timestamp: computePerformanceTime(r.startTime), transactionName: (_a = resources.find(function (kt) { return kt.url === r.name; })) === null || _a === void 0 ? void 0 : _a.name }));
    };
    /**
     * Maps a `PerformanceResourceTiming` entry to a `ResourceMetric`
     * @param r a `PerformanceResourceTiming` entry.
     * @returns a `ResourceMetric`.
     */
    var to_resource_metrics2 = function (r) {
        var _a;
        return (__assign(__assign(__assign({}, getResourcePerformanceMetric(r.name, list)), metricMetadata), { previousTransaction: null, previousTransactionId: null, timestamp: computePerformanceTime(r.startTime), transactionName: (_a = resources.find(function (kt) { return r.name.includes(kt.url); })) === null || _a === void 0 ? void 0 : _a.name }));
    };
    var elementMetrics = [];
    var measureMetrics = [];
    var navigationMetrics = [];
    var paintMetrics = [];
    var resourceMetrics = [];
    /** Hydrate metrics */
    list.getEntries().forEach(function (e, i) {
        switch (e.entryType) {
            case "element": { // for elements timing events
                elementMetrics.push.apply(// for elements timing events
                elementMetrics, [e]
                    .filter(on_watched_elements)
                    .map(to_element_metrics));
                break;
            }
            case "measure": { // For graphql events
                measureMetrics.push.apply(// For graphql events
                measureMetrics, [e]
                    .filter(on_watched_measures)
                    .map(to_measure_metrics));
                break;
            }
            case "navigation": { // For navigation events
                navigationMetrics.push.apply(// For navigation events
                navigationMetrics, [e]
                    .filter(on_watched_navigation)
                    .map(to_navigation_metrics));
                break;
            }
            case "paint": { // For paint events
                paintMetrics.push.apply(// For paint events
                paintMetrics, [e]
                    .filter(on_watched_paints)
                    .map(to_paint_metrics));
                break;
            }
            case "resource": { // for resource events
                resourceMetrics.push.apply(// for resource events
                resourceMetrics, [e]
                    .filter(on_watched_resources2)
                    .map(to_resource_metrics2));
                break;
            }
            default:
                break;
        }
    });
    // Combine metrics
    var metrics = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], elementMetrics, true), measureMetrics, true), navigationMetrics, true), paintMetrics, true), resourceMetrics, true);
    // const apiUrl = getApiUrl();
    // Record metrics
    metrics.length && recordMetrics(metrics, telemetryServiceUrl, beforeSend);
    // Clear the observer to ensure unique telemetry.
    return observer.takeRecords();
}
//# sourceMappingURL=telemetry.js.map